export const LEGACY_AUTH_BOUNDARY_CACHE_NAMES = [
  'api-responses',
  'pages',
] as const;

export const PWA_CACHE_NAMES = [
  ...LEGACY_AUTH_BOUNDARY_CACHE_NAMES,
  'pages-rsc',
  'pages-rsc-prefetch',
  'sol-buyer-next-static',
  'sol-buyer-next-image',
  'sol-buyer-origin-images',
  'sol-buyer-s3-images',
  'sol-buyer-google-fonts-css',
  'sol-buyer-google-fonts-files',
] as const;

const PWA_CACHE_NAME_FRAGMENTS = ['serwist', 'workbox'] as const;

export async function clearPwaSessionCaches() {
  if (typeof caches === 'undefined') {
    return;
  }

  const existingCacheNames = await caches.keys();
  const dynamicPwaCacheNames = existingCacheNames.filter((cacheName) =>
    PWA_CACHE_NAME_FRAGMENTS.some((fragment) => cacheName.includes(fragment))
  );
  const cacheNames = [...new Set([...PWA_CACHE_NAMES, ...dynamicPwaCacheNames])];

  await Promise.allSettled(
    cacheNames.map((cacheName) => caches.delete(cacheName))
  );
}
